"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuthFlow } from "../auth-flow-context";
import { AuthAttemptHandle, AuthCredentialKind, AuthMethodId } from "../types";
import { isSignInWithEmailLink } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { Button, Input, Label } from "@/components/ui";
import { auth } from "@/lib/firebase";
import { authService } from "@/services/auth-service";
type Phase = "loading" | "email-required" | "signing-in" | "error";
export interface EmailLinkMethodProps {
  initialEmail?: string;
}
export function EmailLinkMethod(t0) {
  const $ = _c(28);
  const {
    initialEmail: t1
  } = t0;
  const initialEmail = t1 === undefined ? "" : t1;
  const {
    state,
    actions,
    meta
  } = useAuthFlow();
  const [phase, setPhase] = useState("loading");
  const [email, setEmail] = useState(initialEmail);
  const [emailError, setEmailError] = useState("");
  const isActive = state.activeMethod === AuthMethodId.EMAIL_LINK;
  const flowError = state.errors[AuthMethodId.EMAIL_LINK];
  let t2;
  if ($[0] !== actions || $[1] !== meta) {
    t2 = async (emailToUse, attempt) => {
      setPhase("signing-in");
      const user = await actions.runAuth(AuthMethodId.EMAIL_LINK, () => authService.signInWithEmailLink(emailToUse, window.location.href), attempt);
      if (!user) {
        setPhase("error");
        return;
      }
      await meta.onSuccess({
        kind: AuthCredentialKind.EMAIL_LINK,
        user,
        email: emailToUse
      }, attempt);
    };
    $[0] = actions;
    $[1] = meta;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const redeem = t2;
  let t3;
  let t4;
  if ($[3] !== actions || $[4] !== initialEmail || $[5] !== isActive || $[6] !== redeem) {
    t3 = () => {
      if (!isActive) {
        return;
      }
      if (typeof window === "undefined") {
        return;
      }
      if (!isSignInWithEmailLink(auth, window.location.href)) {
        actions.setError(AuthMethodId.EMAIL_LINK, "This link is not a valid sign-in link. Ask your admin for a new invite.");
        setPhase("error");
        return;
      }
      if (initialEmail) {
        redeem(initialEmail);
      } else {
        setPhase("email-required");
      }
    };
    t4 = [isActive, initialEmail, redeem, actions];
    $[3] = actions;
    $[4] = initialEmail;
    $[5] = isActive;
    $[6] = redeem;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  if (!isActive) {
    return null;
  }
  let t5;
  if ($[9] !== actions || $[10] !== email || $[11] !== redeem) {
    t5 = async e => {
      e.preventDefault();
      if (!email) {
        setEmailError("Email is required");
        return;
      }
      setEmailError("");
      await redeem(email, actions.startAttempt(AuthMethodId.EMAIL_LINK, "credential"));
    };
    $[9] = actions;
    $[10] = email;
    $[11] = redeem;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const onSubmit = t5;
  if (phase === "loading" || phase === "signing-in") {
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <p className="text-center text-body text-foreground-secondary">One moment while we verify your invite link...</p>;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  if (phase === "error") {
    const t6 = flowError ?? "This invite link has expired or is invalid. Ask your admin for a new one.";
    let t7;
    if ($[14] !== t6) {
      t7 = <p className="text-center text-body text-status-error-text" role="alert">{t6}</p>;
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    return t7;
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Label htmlFor="invite-email">Email</Label>;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== emailError) {
    t7 = e_0 => {
      setEmail(e_0.target.value);
      if (emailError) {
        setEmailError("");
      }
    };
    $[17] = emailError;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = !!emailError;
  const t9 = emailError || undefined;
  let t10;
  if ($[19] !== email || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className="space-y-1">{t6}<Input type="email" id="invite-email" autoComplete="email" value={email} onChange={t7} hasError={t8} errorMessage={t9} /></div>;
    $[19] = email;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex justify-center pt-2"><Button variant="primary" type="submit">Continue</Button></div>;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== onSubmit || $[26] !== t10) {
    t12 = <form onSubmit={onSubmit} noValidate={true} className="flex flex-col space-y-4 sm:space-y-5">{t10}{t11}</form>;
    $[25] = onSubmit;
    $[26] = t10;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
}